export interface UserContactData {
  userId: string;
  identUserId: string;
  userName: string;
  firstName: string;
  fullName: string;
  email: boolean;
  phoneNumbers: string[];
  cellPhoneNumbers: string[];
}
